import { EnumList } from 'common/constants/enum';
import { themedStyled } from 'common/styles/styletron.theme';
import { FormState, Input } from 'components/elements';
import { CustomLabel } from 'components/elements/custom-form-control';
import Text from 'components/elements/text';
import UserNameField from 'legacy-modules/master/common/user-name-field';
import EnumSelectInput from 'legacy-modules/master/select-input/enum';
import {
  CardSection,
  FullContainer,
  HalfContainer,
  OneThirdContainer,
  SectionContainer as RawSectionContainer,
  RowBetweenStyles,
  SeparatorVertical,
} from 'legacy-modules/styles';
import useTranslation from 'next-translate/useTranslation';
import * as React from 'react';

export default function GuestInformation() {
  const { t } = useTranslation();

  return (
    <CardSection>
      <Text variant="HeadingXSmall">{t('guest:guest_detail')}</Text>
      <SeparatorVertical $margin={16} />
      <SectionContainer>
        <HalfContainer>
          <UserNameField titleClass={EnumList.GuestTitleType} />
        </HalfContainer>
        <HalfContainer>
          <Input
            type="text"
            name="alias"
            label={t('common:alias')}
            placeholder={t('common:alias')}
          />
        </HalfContainer>
      </SectionContainer>
      <SectionContainer>
        <HalfContainer>
          <Input
            type="radio-group"
            name="gender"
            options={[
              { value: 'male', children: t('common:male') },
              { value: 'female', children: t('common:female') },
            ]}
            label={t('common:gender')}
            align="horizontal"
          />
        </HalfContainer>
        <HalfContainer>
          <EnumSelectInput
            name="category"
            label={t('common:category')}
            placeholder={t('common:category')}
            enumType={EnumList.CategoryType}
            required
          />
        </HalfContainer>
      </SectionContainer>
      <SectionContainer>
        <HalfContainer>
          <FormState>
            {({ editable }) => (
              <CustomLabel
                label={t('common:place_date_of_birth')}
                disabled={!editable}
              />
            )}
          </FormState>
          <FullContainer $style={RowBetweenStyles}>
            <HalfContainer $style={{ width: '47% !important' }}>
              <Input
                type="text"
                name="birthPlace"
                placeholder={t('common:place_of_birth')}
              />
            </HalfContainer>
            <HalfContainer $style={{ width: '47% !important' }}>
              <Input
                type="date-time"
                name="birthDate"
                placeholder="DD/MM/YYYY"
                clearable={false}
              />
            </HalfContainer>
          </FullContainer>
        </HalfContainer>
        <HalfContainer>
          <Input
            type="text"
            name="idNumber"
            label={t('common:id_number')}
            placeholder={t('common:id_number')}
          />
        </HalfContainer>
      </SectionContainer>
      <SectionContainer>
        <OneThirdContainer>
          <Input
            type="email"
            name="email"
            label={t('common:email')}
            placeholder={t('common:email')}
          />
        </OneThirdContainer>
        <OneThirdContainer>
          <Input
            type="tel"
            name="phone"
            label={t('common:phone_number')}
            placeholder={t('common:phone_number')}
          />
        </OneThirdContainer>
        <OneThirdContainer>
          <Input
            type="tel"
            name="phone_2"
            label={t('cruise:cellphone_number')}
            placeholder={t('cruise:cellphone_number')}
          />
        </OneThirdContainer>
      </SectionContainer>
    </CardSection>
  );
}

const SectionContainer = themedStyled(RawSectionContainer, {
  width: '100%',
});
